import { createQueryHook } from '~/shared/providers/api/createQueryHook';

export type Account = {
  id: string;
  name: string;
};

export const useAccountsQuery = createQueryHook(
  'transportation.accounts',
  (params: {
    searchTerm?: string;
    offset?: number;
    limit?: number;
    isCarrier?: boolean;
  }) => ({
    accounts: {
      __args: {
        filter: {
          searchTerm: params.searchTerm ?? '',
          isCarrier: params.isCarrier,
        },
        pagination: {
          offset: params.offset ?? 0,
          limit: params.limit ?? 100,
        },
      },
      entries: {
        id: true,
        name: true,
      },
    },
  }),
  {
    select: (data): { accounts: Account[] } => ({
      accounts:
        data?.accounts.entries.map((entry) => ({
          id: entry.id,
          name: entry.name,
        })) ?? [],
    }),
  },
);
